import { Link, Outlet } from '@tanstack/react-router';
import { Text, YStack } from 'tamagui';

export function SettingsLayout() {
  return (
    <YStack flex={1}>
      <Outlet />
    </YStack>
  );
}

const SETTINGS_ITEMS = [
  { label: 'Mailkonten', description: 'Verbundene Mail-Konten und Lernspeicher', to: '/einstellungen/mail' },
  { label: 'Mail-Tags', description: 'Tags umbenennen, zusammenführen, löschen', to: '/einstellungen/tags' },
  { label: 'Geschäfte', description: 'Verfügbare Geschäfte verwalten', to: '/einstellungen/geschaefte' },
  { label: 'Kalender', description: 'ICS-Feeds für Termine im Tagesplan', to: '/einstellungen/kalender' },
  { label: 'Routinen', description: 'Wiederkehrende Aufgaben (Habits) verwalten', to: '/einstellungen/habits' },
  { label: 'Projekte', description: 'Mehrstufige Vorhaben mit Schritt-Reihenfolge', to: '/einstellungen/projekte' },
  { label: 'OCR-Training', description: 'Fortschritt der gesammelten Trainingsdaten', to: '/einstellungen/training' },
] as const;

export function EinstellungenIndexRoute() {
  return (
    <YStack padding="$4" gap="$2" maxWidth={480}>
      <Text fontSize="$7" fontWeight="700" marginBottom="$2">Einstellungen</Text>
      {SETTINGS_ITEMS.map(({ label, description, to }) => (
        <Link key={to} to={to} style={{ textDecoration: 'none' }}>
          <YStack
            padding="$4"
            borderRadius="$4"
            borderWidth={1}
            borderColor="$borderColor"
            gap="$1"
            hoverStyle={{ backgroundColor: '$color3' }}
            cursor="pointer"
          >
            <Text fontSize="$5" fontWeight="600">{label}</Text>
            <Text fontSize="$3" color="$color10">{description}</Text>
          </YStack>
        </Link>
      ))}
    </YStack>
  );
}
